/* eslint-disable no-debugger */
/* eslint-disable import/no-unresolved */
import ConfirmationModal from "src/shared/ConfirmationModal";
import { useEffect, useLayoutEffect, useState } from "react";
import { useFormik } from "formik";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import { setProposerMedicalLifestylePostDetails } from "src/redux/Thunk";
import { setStepDetails } from "src/redux/Actions/common";
import CustomModal from "src/shared/CustomModal";
import { Button } from "@mui/material";
import {
  calcAgeFromToday,
  checkMedicalField
} from "src/helpers/FormDetails/ProposalDetails/resources";
import store from "src/redux/store";
import { useDispatch } from "react-redux";
import { products } from "src/helpers/FormDetails/resources";
import { ProperdetailMedicalSchema } from "../../../../helpers/FormDetails/ProposalDetails/MedicalAndLifeStyle";
import MedicalAndLifestyle from "../../../../shared/MedicalLifeStyle";
import {
  displayAdditionalQue,
  getQuestionnaireMapper
} from "../../../../helpers/FormDetails/ProposalDetails/MedicalAndLifeStyle/mapper";

function MedicalAndLifeStyle() {
  const dispatch = useDispatch();
  const gender = useAppSelector((state) => state.proposerDetails.general?.gender);

  const proposerStepNumber = useAppSelector((state): any => state.stepDetails.proposerStepNo);
  const parentStepNumber = useAppSelector((state): any => state.stepDetails.parentStepNo);

  const MedicalDetailsInterface = useAppSelector((state: any) => state.medicalAndLifeStyle);
  const [smokerError, setSmokerError] = useState<boolean>(false);
  const [alcoholError, setAlcoholError] = useState<boolean>(false);
  const [frequencyError, setfrequencyError] = useState<boolean>(false);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const proposalStatus = useAppSelector((state) => state.proposalStatus.status);

  const [modalOpen, setModalOpen] = useState(false);
  const productId = useAppSelector((state) => state.common.leadDetails?.productId);
  const partnerId = useAppSelector((state) => state.common?.leadDetails?.partnerId)!;

  const medicalQuestions = getQuestionnaireMapper(productId, partnerId);

  const sumAssured = useAppSelector((state) => state?.common?.leadDetails?.sumAssured);
  const primaryLifeDob = useAppSelector((state) => state?.proposerDetails?.general?.dob) || "";
  const toDisplayAdditionalQue = displayAdditionalQue(sumAssured, primaryLifeDob);

  const age = calcAgeFromToday(primaryLifeDob);
  const nationality = useAppSelector((state) => state.proposerDetails?.general?.nationalityCode);

  const values = useFormik({
    enableReinitialize: true,
    validateOnMount: true,
    validateOnChange: true,
    validateOnBlur: true,
    initialValues: MedicalDetailsInterface,
    validationSchema: ProperdetailMedicalSchema(productId, age, partnerId),

    onSubmit: (fieldValues) => {
      if (proposalStatus !== "MEF Submitted") {
        const nextStepDetails =
          nationality !== "RES"
            ? { proposerStepNo: proposerStepNumber + 1 }
            : { parentStepNo: parentStepNumber + 1, jointStepNo: 1 };
        console.log("printing old field values", fieldValues);

        store.dispatch(
          setProposerMedicalLifestylePostDetails(fieldValues?.medicalDetails, nextStepDetails)
        );
        window.scrollTo(0, 0);
      }
    }
  });

  useEffect(() => {
    if (gender === "Male") {
      values.setFieldValue("medicalDetails.gyneComplications", false);
      values.setFieldValue("medicalDetails.pregnant", false);
      values.setFieldValue("medicalDetails.pregnancyDuration", "");
    }
  }, []);

  useEffect(() => {
    if (!values.values.medicalDetails.alcohol) {
      setAlcoholError(false);
      setfrequencyError(false);
      values.setFieldValue("medicalDetails.beer", false);
      values.setFieldValue("medicalDetails.wine", false);
      values.setFieldValue("medicalDetails.liquor", false);
      values.setFieldValue("medicalDetails.alcoholAmount", "");
      values.setFieldValue("medicalDetails.once", false);
      values.setFieldValue("medicalDetails.lessThanOnce", false);
      values.setFieldValue("medicalDetails.moreThanOnce", false);
      values.setFieldValue("medicalDetails.daily", false);
      values.setFieldValue("medicalDetails.alcoholConsumptionSince", 0);
    }
  }, [values.values.medicalDetails.alcohol]);

  useLayoutEffect(() => {
    const { beer, wine, liquor, once, lessThanOnce, moreThanOnce, daily } =
      values.values.medicalDetails;

    if (!((beer || wine || liquor) && (once || lessThanOnce || moreThanOnce || daily))) {
      values.setFieldValue("medicalDetails.alcoholAmount", "");
    }
  }, [
    values.values.medicalDetails.beer,
    values.values.medicalDetails.wine,
    values.values.medicalDetails.liquor,
    values.values.medicalDetails.once,
    values.values.medicalDetails.lessThanOnce,
    values.values.medicalDetails.moreThanOnce,
    values.values.medicalDetails.daily
  ]);

  useLayoutEffect(() => {
    if (values.values.medicalDetails.measurement === "cm") {
      values.setFieldValue("medicalDetails.height.inchFeet.inches", "");
      values.setFieldValue("medicalDetails.height.inchFeet.feet", "");
    } else {
      values.setFieldValue("medicalDetails.height.centimeter.cm", "");
    }
  }, [values.values.medicalDetails.measurement]);

  useEffect(() => {
    if (!values.values.medicalDetails?.pregnant) {
      values.setFieldValue("medicalDetails.pregnancyDuration", "");
    }
  }, [values.values.medicalDetails.pregnant]);

  useEffect(() => {
    if (
      values.values.medicalDetails.bidi ||
      values.values.medicalDetails.cigaratte ||
      values.values.medicalDetails.gutkha ||
      values.values.medicalDetails.chewing ||
      values.values.medicalDetails.cigar ||
      values.values.medicalDetails.panMasala
    ) {
      setSmokerError(false);
    }
  }, [
    values.values.medicalDetails.bidi ||
      values.values.medicalDetails.cigaratte ||
      values.values.medicalDetails.gutkha ||
      values.values.medicalDetails.chewing ||
      values.values.medicalDetails.cigar ||
      values.values.medicalDetails.panMasala
  ]);
  useEffect(() => {
    if (
      values.values.medicalDetails.beer ||
      values.values.medicalDetails.wine ||
      values.values.medicalDetails.liquor
    ) {
      setAlcoholError(false);
    }
  }, [
    values.values.medicalDetails.beer ||
      values.values.medicalDetails.wine ||
      values.values.medicalDetails.liquor
  ]);

  useEffect(() => {
    if (
      values.values.medicalDetails.daily ||
      values.values.medicalDetails.once ||
      values.values.medicalDetails.lessThanOnce ||
      values.values.medicalDetails.moreThanOnce
    ) {
      setfrequencyError(false);
    }
  }, [
    values.values.medicalDetails.daily ||
      values.values.medicalDetails.once ||
      values.values.medicalDetails.lessThanOnce ||
      values.values.medicalDetails.moreThanOnce
  ]);

  useEffect(() => {
    // console.log("joint formik", values);
    if (!values.values.medicalDetails.smoker) {
      setSmokerError(false);
      values.setFieldValue("medicalDetails.bidi", false);
      values.setFieldValue("medicalDetails.bidiAmount", "");
      values.setFieldValue("medicalDetails.cigaratteAmount", "");
      values.setFieldValue("medicalDetails.cigaratte", false);
      values.setFieldValue("medicalDetails.gutkhaAmount", "");
      values.setFieldValue("medicalDetails.gutkha", false);
      values.setFieldValue("medicalDetails.chewing", false);
      values.setFieldValue("medicalDetails.chewingAmount", "");
      values.setFieldValue("medicalDetails.cigar", false);
      values.setFieldValue("medicalDetails.cigarAmount", "");
      values.setFieldValue("medicalDetails.panMasala", false);
      values.setFieldValue("medicalDetails.panMasalaAmount", "");
      values.setFieldValue("medicalDetails.smokingConsumptionSince", 0);
    }
  }, [values.values.medicalDetails.smoker]);
  useEffect(() => {
    if (!values.values.medicalDetails.cigaratte) {
      values.setFieldValue("medicalDetails.cigaratteAmount", "");
      values.setFieldValue("medicalDetails.cigaratte", false);
    }
    if (!values.values.medicalDetails.bidi) {
      values.setFieldValue("medicalDetails.bidiAmount", "");
      values.setFieldValue("medicalDetails.bidi", false);
    }
    if (!values.values.medicalDetails.cigar) {
      values.setFieldValue("medicalDetails.cigarAmount", "");
      values.setFieldValue("medicalDetails.cigar", false);
    }
    if (!values.values.medicalDetails.gutkha) {
      values.setFieldValue("medicalDetails.gutkhaAmount", "");
      values.setFieldValue("medicalDetails.gutkha", false);
    }
    if (!values.values.medicalDetails.chewing) {
      values.setFieldValue("medicalDetails.chewingAmount", "");
      values.setFieldValue("medicalDetails.chewing", false);
    }
    if (!values.values.medicalDetails.panMasala) {
      values.setFieldValue("medicalDetails.panMasalaAmount", "");
      values.setFieldValue("medicalDetails.panMasala", false);
    }
  }, [
    values.values.medicalDetails.cigaratte,
    values.values.medicalDetails.bidi,
    values.values.medicalDetails.cigar,
    values.values.medicalDetails.gutkha,
    values.values.medicalDetails.chewing,
    values.values.medicalDetails.panMasala
  ]);

  useLayoutEffect(() => {
    if (!values.values.medicalDetails?.familyHealthHistory) {
      values.setFieldValue("medicalDetails", {
        ...values.values.medicalDetails,
        familyMedicalHistory: [
          {
            familyPersonName: "",
            familyRelation: "",
            status: "Alive",
            sufferingAge: "",
            ageOfDeath: "",
            presentStateOfHealth: "",
            causeDeath: ""
          }
        ]
      });
    }
  }, [values.values.medicalDetails?.familyHealthHistory]);
  const handleMedicalForm = () => {
    let smokerErr: boolean = false;
    let alcoholErr: boolean = false;
    let openErrorBox: boolean = false;
    let frequencyErr: boolean = false;
    if (
      values.values.medicalDetails.smoker &&
      !values.values.medicalDetails.bidi &&
      !values.values.medicalDetails.cigaratte &&
      !values.values.medicalDetails.gutkha &&
      !values.values.medicalDetails.chewing &&
      !values.values.medicalDetails.cigar &&
      !values.values.medicalDetails.panMasala
    ) {
      setModalOpen(true);
      openErrorBox = true;
      setSmokerError(true);
      smokerErr = true;
    }
    if (
      values.values.medicalDetails.alcohol &&
      !values.values.medicalDetails.beer &&
      !values.values.medicalDetails.wine &&
      !values.values.medicalDetails.liquor
    ) {
      setModalOpen(true);
      openErrorBox = true;
      setAlcoholError(true);
      alcoholErr = true;
    }
    if (
      values.values.medicalDetails.alcohol &&
      !values.values.medicalDetails.moreThanOnce &&
      !values.values.medicalDetails.once &&
      !values.values.medicalDetails.lessThanOnce &&
      !values.values.medicalDetails.daily
    ) {
      setModalOpen(true);
      openErrorBox = true;
      setfrequencyError(true);
      frequencyErr = true;
    }
    if (!openErrorBox) {
      setModalOpen(!values.isValid);
    }

    if (!smokerErr && !alcoholErr && !openErrorBox && !frequencyErr && !values.isValid) {
      values.handleSubmit();
    } else if (!smokerErr && !alcoholErr && !openErrorBox && !frequencyErr) {
      if (checkMedicalField(values.values?.medicalDetails)) values.handleSubmit();
      else setOpenConfirmationModal(true);
    }
  };

  useEffect(() => {
    if ([products?.GHS, products?.GHS_FOR_JIO, products?.GHS_IDBI]?.includes(productId)) {
      values.setFieldValue("medicalDetails.declare", false);
    }
  }, [productId]);

  useEffect(() => {
    if (!values?.values?.medicalDetails?.otherDisease)
      values.setFieldValue("medicalDetails.otherDiseaseDetails", "");
  }, [values?.values?.medicalDetails?.otherDisease]);

  return (
    <div>
      {openConfirmationModal && (
        <ConfirmationModal
          text={
            <div>
              <p>
                Dear Customer, you have answered all health questions as “NO”, if you want to make
                any changes to any of the answers, please resubmit the response.
              </p>
              <p className="text-sm mt-3">If not, then please proceed further.</p>
            </div>
          }
          onNext={() => values.handleSubmit()}
          onCancel={() => setOpenConfirmationModal(false)}
        />
      )}
      <CustomModal modalOpen={modalOpen} setModalOpen={setModalOpen} />
      <MedicalAndLifestyle
        questions={medicalQuestions}
        displayAdditionalQue={toDisplayAdditionalQue}
        formValues={values.values}
        setFieldValue={values.setFieldValue}
        handleBlurs={values.handleBlur}
        handleChanges={values.handleChange}
        isReview={false}
        gender={gender}
        label="Self"
        error={values.errors}
        touch={values.touched}
        setFieldTouch={values.setFieldTouched}
        fieldObj="medicalDetails"
        smokerError={smokerError}
        alcoholError={alcoholError}
        frequencyError={frequencyError}
      />
      <div className="flex mt-10 justify-center">
        <Button
          variant="outlined"
          classes={{ outlined: "!rounded-lg" }}
          onClick={() => {
            dispatch(setStepDetails({ proposerStepNo: 3 }));
            window.scrollTo(0, 0);
          }}
          className="!text-black !uppercase h-13 w-37.5 rounded-xl !mr-10"
        >
          Back
        </Button>
        <Button
          variant="contained"
          classes={{ contained: "!rounded-lg" }}
          onClick={handleMedicalForm}
          className="!uppercase h-13 w-37.5"
        >
          NEXT
        </Button>
      </div>
    </div>
  );
}

export default MedicalAndLifeStyle;
